<template>
  <div
    class="row me-1 link-ri-button align-items-center pointer"
    title="สำหรับดูข้อมูลวิเคราห์เชิงลึก"
    @click="handleClickRedirectToRuejaiIntelligence"
  >
    <img
      style="height: 16px;"
      src="/static/icons/ri-favicon.svg"
    />
    <div
      class="ms-1"
      style="text-decoration: underline; font-size: 14px;"
    >RI Insight</div>
  </div>
</template>

<script>

export default {
  props: {
    link: {
      type: String,
      required: true
    }
  },
  methods: {
    handleClickRedirectToRuejaiIntelligence() {
      window.open(`${process.env.RUEJAI_INTELLIGENCE_HOST}/ruejai-intelligence/external_access/ruejai_admin_auth?link=${this.link}`, '_blank');
    }
  }
};
</script>

<style lang="scss" scoped>
.link-ri-button {
  background: none;
  border: solid 1px grey;
  padding: 8px;
  cursor: pointer;
  border-radius: 8px;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: #f5f5f5;
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
}
</style>
